export const EPixKeyType = {
  Undefined: 0,
  Cpf: 1,
  Cnpj: 2,
  Email: 3,
  Phone: 4,
  Random: 5,
} as const

export type EPixKeyType = (typeof EPixKeyType)[keyof typeof EPixKeyType]
